/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Avatar from '@atlaskit/avatar';
import { N600, N30A, N40A } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

type CircleButtonProps = {
	count: number;
	onClick: (event: React.MouseEvent, analyticsEvent?: UIAnalyticsEvent) => void;
};

const UnshownCount = ({ count, onClick }: CircleButtonProps) => {
	const { formatMessage } = useIntl();

	return (
		<Avatar appearance="circle" size="small" onClick={onClick}>
			{({ testId: _, className, ref, ...props }) => (
				<button
					aria-label={formatMessage(messages.openModalButtonAriaLabel)}
					// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
					ref={ref as any}
					css={buttonStyles}
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
					className={className}
					{...props}
				>{`+${count}`}</button>
			)}
		</Avatar>
	);
};

export default UnshownCount;

const buttonStyles = css({
	font: token('font.body.small'),
	fontColor: token('color.text.subtle', N600),
	backgroundColor: token('color.background.neutral', N30A),
	'&:hover': { backgroundColor: token('color.background.neutral.hovered', N40A) },
	border: 'none',
	boxShadow: 'none',
});
